import $ from 'jquery';

const initSite = function initSite() {
  const $site = $('.main-content');

  $(window).on('load', () => {
    $site.addClass('loaded');
  });

  const $links = $(
    'a:not([href^="#"], [href^="tel:"] [href^="mailto:"], [data-dropdown], [target="_blank"])',
  );
  $links.click(ev => {
    ev.preventDefault();
    let $self = $(ev.target);
    if (!$self.attr('href')) {
      $self = $self.closest('a');
    }
    $site.removeClass('loaded');
    setTimeout(() => {
      window.location = $self.attr('href');
    }, 350);
  });
};
export default initSite;



// WEBPACK FOOTER //
// ./src/scripts/modules/init-site.js